import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  CornerDownLeft,
  FiEdit,
  FiLink,
  FiSearch,
  FiTrash2,
} from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  InputGroup,
  InputGroupText,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import { getInventoryPurchaseRtn } from "../../../../redux/inventory";
import { useNavigate } from "react-router-dom";
import PurchaseForm from "./PurchaseForm";

const PurchaseReturns = () => {
  const itemsList = useSelector((state) => state.inventory);
  const dispatch = useDispatch();
  const { supplierData, purchaseRtnData } = itemsList;
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  const [formData, setFormData] = useState("");
  const [modal, setModal] = useState(false);
  const [modalItems, setModalItems] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [popoverData, setPopoverData] = useState("");
  const toggle = () => setModal(!modal);
  const toggleModalItems = () => setModalItems(!modalItems);
  const [mode, setMode] = useState("");

  const editReturnHandler = (Data, toggle, type) => {
    setMode(type);
    setFormData(Data);
    toggle();
  };

  useEffect(() => {
    if (userData.token && userData.branch)
      dispatch(
        getInventoryPurchaseRtn({
          token: userData.token,
          branch: userData.branch,
        })
      );
  }, [userData.token, userData.branch]);

  const deleteHandler = (item, itemId) => {
    const slno = prompt("Please enter the SL No. to confirm delete");

    if (slno && Number(slno.trim()) === itemId) {
      axios
        .delete(`${process.env.REACT_APP_CRI_API}delete-rtn-purchase`, {
          params: { id: item._id, branch: userData.branch },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        })
        .then((res) => {
          if (res) {
            dispatch(
              getInventoryPurchaseRtn({
                token: userData.token,
                branch: userData.branch,
              })
            );
          }
        })
        .catch((err) => {
          if (
            (err.response.data &&
              err.response.data.err &&
              err.response.data.err.name === "TokenExpiredError") ||
            err.response.data.message === "Unauthorized"
          ) {
            navigate("/");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("srchData");
            sessionStorage.removeItem("prescriptionHistory");
            sessionStorage.removeItem("rights");
            navigate("/cri-crm");
            return err;
          }
        });
    } else if (slno) {
      alert("Contact No. not matching");
    }
  };
  const supplierNameHandler = (supplierId) => {
    const supplier = supplierData.find(
      (item) => item.supplierId === supplierId
    );
    if (supplier) return supplier.supplierName;
    return null;
  };

  return (
    <Container fluid>
      <Row>
        <Col md={3} className="pt-4">
          {" "}
          <InputGroup className="mb-4">
            <Input
              // color="primary"
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search Item"
            />
            <InputGroupText>
              {" "}
              <FiSearch />
            </InputGroupText>
          </InputGroup>
        </Col>
      </Row>
      <>
        <Row className="d-flex justify-content-center">
          <Col sm={3} style={{ textAlign: "center" }}>
            <h5>Purchase Returns</h5>
          </Col>
        </Row>

        {!purchaseRtnData.length && "No Data - "}
        {purchaseRtnData && purchaseRtnData.length && (
          <Table responsive striped>
            <thead>
              <tr className="table-secondary">
                <th style={{ width: "70px" }}>Sl No.</th>
                <th style={{ width: "20%" }}>Supplier Name</th>
                <th>Invoice Date</th>
                <th>Invoice No</th>
                <th>Credit</th>
                <th>Return Reason</th>
                <th>Items</th>

                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {purchaseRtnData
                .filter(
                  (item) =>
                    !searchInput ||
                    (item.supplier &&
                      supplierNameHandler(item.supplier?.supplierId)
                        .toLowerCase()
                        .includes(searchInput.toLowerCase()))
                )
                .map((item, id) => {
                  return (
                    <tr key={id}>
                      <td style={{ textAlign: "center" }}>{id + 1}</td>
                      <td style={{ width: "200px" }}>
                        {supplierNameHandler(item.supplier?.supplierId)}{" "}
                      </td>
                      <td>
                        {new Date(
                          item.paymentDetails?.invoice_date
                        ).toLocaleDateString()}
                      </td>
                      <td>{item.paymentDetails?.invoice_id}</td>
                      <td>{item.additionalDetails?.credit}</td>
                      <td>{item.additionalDetails?.returnReason}</td>
                      <td>
                        <FiLink
                          style={{ cursor: "pointer" }}
                          id="invoiceItems"
                          type="button"
                          onClick={() => {
                            setPopoverData(item.invoice);
                          }}
                        />
                      </td>

                      <td>
                        {(userData.rights === "Admin" ||
                          userData.rights === "Manager" ||
                          userData.rights === "Accounts") && (
                          <FiEdit
                            color="green"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              editReturnHandler(item, toggle, "Return Mode");
                            }}
                          />
                        )}
                      </td>
                      <td>
                        {" "}
                        {(userData.rights === "Admin" ||
                          userData.rights === "Manager" ||
                          userData.rights === "Accounts") && (
                          <FiTrash2
                            color="red"
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteHandler(item, id + 1)}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
      </>
      <Modal isOpen={modal} toggle={toggle} fullscreen>
        <ModalHeader toggle={toggle}>{mode}</ModalHeader>
        <ModalBody>
          <PurchaseForm
            editFormData={formData}
            togglePurchaseEntry={toggle}
            mode={mode}
          />
        </ModalBody>
        <ModalFooter>
          <button onClick={toggle}>Close</button>
        </ModalFooter>
      </Modal>

      {purchaseRtnData && purchaseRtnData.length && (
        <UncontrolledPopover
          placement="bottom"
          target="invoiceItems"
          trigger="legacy"
          // hide={() => setPopoverData("")}
        >
          <PopoverHeader>Invoice Items</PopoverHeader>
          <PopoverBody>
            <Table>
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Item</th>
                  <th>Price</th>
                  <th>QTY</th>
                </tr>
              </thead>
              <tbody>
                {popoverData &&
                  Object.values(popoverData)
                    .filter((row) => Object.values(row)[0].item !== "")
                    .map((row, ind) => (
                      <tr key={ind}>
                        <td style={{ minWidth: "10px" }}>{ind + 1}</td>
                        <td>{Object.values(row)[0].item}</td>
                        <td>{Object.values(row)[0].unitPrice}</td>
                        <td>{Object.values(row)[0].quantity}</td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </Container>
  );
};

export default PurchaseReturns;
